/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_PreviewInputs */

const zh_publish_preview = /** @type {(inputs: Publish_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览`)
};

const en_publish_preview = /** @type {(inputs: Publish_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview`)
};

const es_publish_preview = /** @type {(inputs: Publish_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa`)
};

/**
* | output |
* | --- |
* | "Preview" |
*
* @param {Publish_PreviewInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const publish_preview = /** @type {((inputs?: Publish_PreviewInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_PreviewInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_publish_preview(inputs)
	if (locale === "en") return en_publish_preview(inputs)
	return es_publish_preview(inputs)
});